import styled from 'styled-components';

type FilterStatusProps = {
  isOpen: boolean
}

export const Container = styled.div<FilterStatusProps>`
  position: fixed;
  width: 320px;
  height: 100vh;
  background: white;
  box-shadow: 0 5px 5px 5px gray;
  top: 0;
  right: ${props => props.isOpen ? '0' : '-325px'};
  /* right: 0; */
  z-index: 9999;
  transition: 0.3s;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 3px solid green;
  padding: 10px 0;
`;

export const CloseIcon = styled.div`
  padding-right: 15px;
  :hover {
    color: green;
    cursor: pointer;
  }
`;

export const Title = styled.div`
  font-weight: bold;
  font-size: 22px;
  padding-left: 15px;
`;

export const Filters = styled.div`
  display: block;
  margin: 20px 0;
  padding: 0 10px;
  width: 100%;
`;

export const Filter = styled.div`
  padding: 10px 0;
  border-bottom: 1px solid lightgray;
`;

export const ClearButton = styled.div`
  padding: 10px 15px;
  background-color: #316944;
  border: 1px solid lightgray;
  width: 170px;
  text-align: center;
  border-radius: 3px;
  margin-bottom: 20px;
  width: 100%;
  color: white;

  :hover {
    cursor: pointer;
    color: lightgray;
  }
`;